import { render, staticRenderFns } from "./Promocode.vue?vue&type=template&id=cff7c740&lang=pug&"
import script from "./Promocode.vue?vue&type=script&lang=js&"
export * from "./Promocode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports